// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1SL4Y","container":"styles_container__1KgJ5","title":"styles_title__2V1xd","wrapper":"styles_wrapper__AORkm","answer":"styles_answer__2E8Ga"};